// pfs-card-body.ts — die Body-Zone der Card (PFS-756), symmetrisch zu
// <pfs-card-header>.
//
// Benannte Body-Region der Card: trägt die Section-Rhythmik (gap) für den
// Card-Inhalt und ist die semantische Heimat für künftige Body-Nähte
// (collapsible-Target, Body-States). Das INSET-Padding liefert die <pfs-card>-
// Body-Region (SSOT für die Card-Struktur) — <pfs-card-body> doppelt es NICHT.
//
//   Sektioniert: die Zone unter dem Header-Band.
//     <pfs-card data-sectioned>
//       <pfs-card-header slot="header" …></pfs-card-header>
//       <pfs-card-body> … </pfs-card-body>
//     </pfs-card>
//
//   Flach: die einzige Zone — der Header liegt dann als Kind hier drin.
//     <pfs-card>
//       <pfs-card-body>
//         <pfs-card-header …></pfs-card-header>
//         … Inhalt …
//       </pfs-card-body>
//     </pfs-card>
//
// Rhythmik via --pfs-space-section (am :root überschreibbar). Keine eigene
// Optik: Surface/Border/Radius/Shadow gehören der <pfs-card>-Schale, das Inset
// der <pfs-card>-Body-Region.
import { defineComponent } from "../../composition/define-component.js";
import { withShadow } from "../../composition/with-shadow.js";

const STYLES = `
:host {
  display: flex;
  flex-direction: column;
  gap: var(--pfs-space-section, 1rem);
}
`;

defineComponent({
  tagName: "pfs-card-body",
  eager: true,
  mixins: [withShadow()],
  render(_host, ctx) {
    const root = ctx.shadowRoot;
    if (!root) return;
    const style = document.createElement("style");
    style.textContent = STYLES;
    root.append(style, document.createElement("slot"));
  },
});
